function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { DefaultRenderEdge, DefaultRenderNode, Graph } from "./..";
import { getLabel, getSelectedItemByElement } from "../../utils";
import { EDITOR_MODE, EVENT } from "../../utils/constants";
import React from 'react';
import { View, wrapComponent, useForwardRef } from 'unitx-ui';
import * as R from 'unitx/ramda';
import ActionBar, { ACTION } from "./ActionBar";
import DataBar from "./DataBar";
import SettingsBar from "./SettingsBar";
import { MouseIcon } from "./MouseIcon";
// const MODE_ICON_MAP = {
//   [EDITOR_MODE.ADD]: 'plus',
//   [EDITOR_MODE.DELETE]: 'minus',
//   [EDITOR_MODE.CONTINUES_ADD]: 'plus-circle-outline',
//   [EDITOR_MODE.CONTINUES_DELETE]: 'minus-circle-outline',
//   [EDITOR_MODE.DEFAULT]: null,
// }
const MODE_ICON_SCALE = 0.8;
const MODE_ICON_MAP_BY_URL = {
  [EDITOR_MODE.ADD]: `https://img.icons8.com/material/${MODE_ICON_SCALE}x/plus-math.png`,
  [EDITOR_MODE.DELETE]: `https://img.icons8.com/material/${MODE_ICON_SCALE}x/minus--v2.png`,
  [EDITOR_MODE.CONTINUES_ADD]: `https://img.icons8.com/material/${MODE_ICON_SCALE}x/plus.png`,
  [EDITOR_MODE.CONTINUES_DELETE]: `https://img.icons8.com/material/${MODE_ICON_SCALE}x/minus-sign.png`,
  [EDITOR_MODE.DEFAULT]: null
};
const DEFAULT_HANDLER = R.identity;

const GraphEditorElement = (props, ref) => {
  var _label$global;

  const {
    onEvent = DEFAULT_HANDLER,
    renderEdge,
    renderNode,
    graphConfig,
    style,
    settingsBar,
    actionBar,
    dataBar = {},
    nodes,
    edges,
    selectedElement,
    label,
    mode = EDITOR_MODE.DEFAULT
  } = props,
        rest = _objectWithoutProperties(props, ["onEvent", "renderEdge", "renderNode", "graphConfig", "style", "settingsBar", "actionBar", "dataBar", "nodes", "edges", "selectedElement", "label", "mode"]);

  const graphEditorRef = useForwardRef(ref);
  const selectedItem = selectedElement && getSelectedItemByElement(selectedElement, {
    nodes,
    edges
  }).item;
  const selectedElementIsNode = selectedElement && selectedElement.isNode();
  const targetPath = selectedElementIsNode ? 'nodes' : 'edges';
  const selectedElementRef = React.useRef({
    selectedElement,
    selectedItem
  });
  selectedElementRef.current = {
    selectedElement,
    selectedItem
  };
  const onEventCallback = React.useCallback(eventInfo => {
    const {
      selectedElement,
      selectedItem
    } = selectedElementRef.current;
    onEvent(_objectSpread(_objectSpread({
      element: selectedElement,
      item: selectedItem
    }, eventInfo), {}, {
      graphEditor: graphEditorRef.current
    }));
  }, [selectedElement, selectedItem]);
  return /*#__PURE__*/React.createElement(View, {
    style: style
  }, /*#__PURE__*/React.createElement(Graph // @ts-ignore
  , _extends({
    ref: graphEditorRef,
    style: {
      width: '100%',
      height: '100%'
    },
    nodes: nodes,
    edges: edges
  }, rest, {
    extraData: {
      label,
      extraData: rest.extraData
    },
    config: graphConfig,
    onPress: ({
      position
    }) => {
      onEventCallback({
        type: EVENT.PRESS_BACKGROUND,
        extraData: position
      });
    },
    renderNode: (_ref) => {
      var _label$global$nodes, _label$nodes, _label$nodes$item$id, _label$nodes2;

      let {
        item,
        element
      } = _ref,
          rest = _objectWithoutProperties(_ref, ["item", "element"]);

      return /*#__PURE__*/React.createElement(Graph.Pressable, {
        onPress: () => onEventCallback({
          type: EVENT.ELEMENT_SELECTED,
          item,
          element
        })
      }, (renderNode !== null && renderNode !== void 0 ? renderNode : DefaultRenderNode)(_objectSpread({
        item,
        element,
        // @ts-ignore
        label: getLabel((label === null || label === void 0 ? void 0 : label.isGlobalFirst) ? (_label$global$nodes = label === null || label === void 0 ? void 0 : label.global.nodes) !== null && _label$global$nodes !== void 0 ? _label$global$nodes : label === null || label === void 0 ? void 0 : (_label$nodes = label.nodes) === null || _label$nodes === void 0 ? void 0 : _label$nodes[item.id] : (_label$nodes$item$id = label === null || label === void 0 ? void 0 : (_label$nodes2 = label.nodes) === null || _label$nodes2 === void 0 ? void 0 : _label$nodes2[item.id]) !== null && _label$nodes$item$id !== void 0 ? _label$nodes$item$id : label === null || label === void 0 ? void 0 : label.global.nodes, item)
      }, rest)));
    },
    renderEdge: (_ref2) => {
      var _label$global$edges, _label$edges, _label$edges$item$id, _label$edges2;

      let {
        item,
        element
      } = _ref2,
          rest = _objectWithoutProperties(_ref2, ["item", "element"]);

      return /*#__PURE__*/React.createElement(Graph.Pressable, {
        onPress: () => onEventCallback({
          type: EVENT.ELEMENT_SELECTED,
          item,
          element
        })
      }, // @ts-ignore
      (renderEdge !== null && renderEdge !== void 0 ? renderEdge : DefaultRenderEdge)(_objectSpread({
        item,
        // @ts-ignore
        label: getLabel((label === null || label === void 0 ? void 0 : label.isGlobalFirst) ? (_label$global$edges = label === null || label === void 0 ? void 0 : label.global.edges) !== null && _label$global$edges !== void 0 ? _label$global$edges : label === null || label === void 0 ? void 0 : (_label$edges = label.edges) === null || _label$edges === void 0 ? void 0 : _label$edges[item.id] : (_label$edges$item$id = label === null || label === void 0 ? void 0 : (_label$edges2 = label.edges) === null || _label$edges2 === void 0 ? void 0 : _label$edges2[item.id]) !== null && _label$edges$item$id !== void 0 ? _label$edges$item$id : label === null || label === void 0 ? void 0 : label.global.edges, item)
      }, rest)));
    }
  })), /*#__PURE__*/React.createElement(DataBar, _extends({}, dataBar, {
    item: selectedItem,
    localLabel: selectedElement && (label === null || label === void 0 ? void 0 : label[targetPath][selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id]),
    globalLabel: label === null || label === void 0 ? void 0 : (_label$global = label.global) === null || _label$global === void 0 ? void 0 : _label$global[targetPath],
    isGlobalLabelFirst: label === null || label === void 0 ? void 0 : label.isGlobalFirst,
    onEvent: onEventCallback
  })), settingsBar && /*#__PURE__*/React.createElement(SettingsBar, _extends({}, settingsBar, {
    onEvent: onEventCallback
  })), actionBar && /*#__PURE__*/React.createElement(ActionBar, _extends({
    onEvent: onEvent,
    graphEditorRef: graphEditorRef,
    mode: mode,
    graphConfig: graphConfig,
    onAction: ({
      type
    }) => {
      switch (type) {
        case ACTION.EXPORT_DATA:
          onEventCallback({
            type: EVENT.EXPORT_DATA,
            extraData: {
              value: extractGraphEditorData(props)
            }
          });
          break;

        default:
          break;
      }
    }
  }, actionBar)), /*#__PURE__*/React.createElement(MouseIcon // name={MODE_ICON_MAP[mode]}
  , {
    name: MODE_ICON_MAP_BY_URL[mode],
    cursor: true
  }));
};

const extractGraphEditorData = props => {
  // const x = {}
  return {
    graphConfig: props.graphConfig,
    label: props.label,
    settingsBar: props.settingsBar,
    dataBar: props.dataBar,
    actionBar: props.actionBar,
    mode: props.mode,
    nodes: props.nodes,
    edges: props.edges
  };
};
/**
 * ## Usage
 * To create a GraphEditor easily, you can just pass data and render methods.
 * Check example
 *
 * ```js live=true
 * function MyGraphEditor() {
 *  const [data, setData] = React.useState({
 *    nodes: [
 *         { id: 1, position: { x: 10, y: 10 } },
 *         { id: 2, position: { x: 300, y: 100 } },
 *       ],
 *    edges: [
 *         { id: 51, source: 1, target: 2 }
 *       ]
 *  })
 *  return (
 *    <GraphEditor
 *       style={{ width: '100%', height: 250 }}
 *       configExtractor={({ item }) => ({ data: { data: item }})}
 *       nodes={data.nodes}
 *       edges={data.edges}
 *     />
 *  )
 * }
 * ```
 */


export const GraphEditor = wrapComponent(GraphEditorElement, {
  isEqual: R.equalsExclude(R.isFunction),
  isForwardRef: true
});